
import ContactUs from "../../components/ContactUs";
import PlanCards from "../../components/PlanCardSection";
import SliderViewSection from "../../components/SliderViewSection";
import StayInLoop from "../../components/StayInLoop";
import TestimonialSlider from "../../components/FeedbackSlider";
import { CardSwapImg, Avalanche1,
 Avalanche2,
 Avalanche3,
 Avalanche4,
 Avalanche5,
 Avalanche6, 
 AllProductGif} from "../../constant";
import ProductLanding from "../../components/Products/ProductLanding";
import CardCrausalView from "../../components/CardCrausalView";

const safetyAndSustainabilityData = [
  {
    title:
      "Avalanche is Your Enterprise Decision Support System.",

    subtitle:
      "AVALANCHE enables organizations to identify, assess, mitigate and monitor enterprise risks through connected workflows, governance structures and intelligence-driven decision support.",

    lists: [
      "Enterprise-Wide Risk Visibility",
      "Structured Risk Governance",
      "Connected Mitigation Workflows",
      "Faster and informed decision-making",
    ],

    mediaUrl:
Avalanche1  },

  {
    title:
      "Managing Risk Across the Entire ERM Journey.",

    subtitle:
      "Digitize and streamline the complete enterprise risk management lifecycle from identification and assessment to mitigation, monitoring and governance.",

    lists: [
      "Risk Identification & Assessment",
      "Centralized Risk Registers",
      "Mitigation & Action Tracking",
      "Continuous Monitoring & Review",
    ],

    mediaUrl:
Avalanche2  },

  {
    title:
      "Built Around Global Risk Frameworks.",

    subtitle:
      "AVALANCHE supports structured enterprise risk management aligned with globally recognized governance and risk frameworks.",

    lists: [
      "COSO-Aligned ERM Structure",
      "ISO 31000 Risk Management Support",
      "Governance-Driven Workflows",
      "Standardized risk taxonomy & controls",
    ],

    mediaUrl:
Avalanche3 },

  {
    title:
      "Discover Emerging & Hidden Risks with AI.",

    subtitle:
      "Leverage AI-driven analytics and connected risk intelligence to identify patterns, dependencies, emerging threats and hidden enterprise risks.",

    lists: [
      "AI-Driven Risk Correlations",
      "Connected Risk Network Maps",
      "Predictive Risk Insights",
      "Intelligent Mitigation Recommendations",
    ],

    mediaUrl:
Avalanche4  },

  {
    title:
      "Connected Workflows for Enterprise Governance.",

    subtitle:
      "Enable cross-functional collaboration, approvals, escalations and accountability through workflow-driven enterprise risk management.",

    lists: [
      "Workflow-Driven Governance",
      "Role-Based Accountability",
      "Mitigation Ownership Tracking",
      "Cross-Functional Collaboration",
    ],

    mediaUrl:
Avalanche5  },

  {
    title:
      "Strengthening Resilience Through Risk Intelligence.",

    subtitle:
      "Transform enterprise risk management into a strategic capability that improves resilience, operational continuity, compliance readiness and business performance.",

    lists: [
      "Proactive Risk Mitigation",
      "Improved Operational Resilience",
      "Better Strategic Decision-Making",
      "Enhanced Enterprise Performance",
    ],

    mediaUrl:
Avalanche6  },
];


const AuroraSRPPlans = [
  {
    title: "Basic",

    subtitle:
      "Designed for foundational enterprise risk management and governance visibility.",

    features: [
      "Risk Identification & Assessments",
      "Centralized Risk Registers",
      "Workflow-Driven Approvals",
      "Standard Risk Dashboards",
    ],
  },

  {
    title: "Advanced",

    subtitle:
      "Built for connected enterprise risk intelligence with deeper analytics and governance workflows.",

    features: [
      "Enterprise-Wide Risk Visibility",
      "Advanced Risk Analytics",
      "Mitigation Tracking Workflows",
      "Cross-Functional Risk Collaboration",
      "Governance & Compliance Monitoring",
    ],

    popular: true,
  },

  {
    title: "Premium",

    subtitle:
      "Comprehensive risk intelligence platform for predictive governance, connected risk ecosystems and strategic decision support.",

    features: [
      "AI-Driven Risk Intelligence",
      "Connected Risk Network Mapping",
      "Predictive & Prescriptive Insights",
      "COSO & ISO-Aligned Governance Frameworks",
      "Enterprise Resilience & Performance Intelligence",
    ],

    recommended: true,
  },
];

const testimonialsData = [
  {
    quote:
      "NetZero enabled us to streamline ESG reporting and improve sustainability visibility across operations.",
    author: "General Manager, EHS",
    note: "An Integrated Energy Enterprise",
  },
  {
    quote:
      "The platform transformed our EHS processes with real-time monitoring, analytics, and actionable insights.",
    author: "Project Safety Head",
    note: "Major Oil & Gas Operator",
  },
  {
    quote:
      "Aurora helped us connect critical industrial assets and improve operational efficiency significantly.",
    author: "Project Manager",
    note: "An Integrated Oil & Gas Operator",
  },
  {
    quote:
      "We now manage compliance, audits, and sustainability reporting from a single intelligent platform.",
    author: "Head, Digital Transformation",
    note: "A Large Mining Company",
  },
  {
    quote:
      "Implementation was seamless, and the solution scaled perfectly across our enterprise operations.",
    author: "Chief Manager – Projects",
    note: "A Large Refining Company",
  },
  {
    quote:
      "The risk engagement simplified complex reporting requirements while improving data accuracy and governance.",
    author: "Chief Risk Officer",
    note: "A Large Power Generation Company",
  },
  {
    quote:
      "Connected operational intelligence and sustainability insights helped us achieve measurable business outcomes.",
    author: "Head – Projects",
    note: "One of the Largest EPC Players",
  },
  {
    quote:
      "Real-time visibility into risks, emissions, and compliance improved our overall operational performance.",
    author: "Head – Sustainability",
    note: "A Large Defence Manufacturer",
  },
  {
    quote:
      "A modern digital transformation platform that delivers measurable impact across EHS, ESG, and operations.",
    author: "Nodal Officer, Digital Initiatives",
    note: "One of the Largest Mining Operators",
  },
];

const cardData = [
  {
    title: "Connected Risk Intelligence",
    description:
      "Identify emerging and hidden enterprise risks through connected risk data, cross-functional visibility and AI-driven intelligence.",
  },

  {
    title: "AI-Powered Risk Insights",
    description:
      "Leverage AI to detect patterns, prioritize critical risks, recommend mitigations and strengthen proactive decision-making.",
  },

  {
    title: "Enterprise Risk Governance",
    description:
      "Enable structured risk assessments, mitigation workflows, accountability and continuous monitoring across the ERM lifecycle.",
  },
];


export default function ProductAvalanche() {
  return (
    <>
      <ProductLanding
        title={`Risk Intelligence to Drive Enterprise Resilience`}
        subTitle={`AVALANCHE enables organizations to digitize and streamline enterprise risk management through structured workflows, centralized risk registers, risk assessments, mitigation planning, and governance aligned with global frameworks.`}
        isNetzero={false}
        url={AllProductGif}
      />
      <CardCrausalView
        title={`AVALANCE. One Platform for Integrated Risk Intelligence`}
        subTitle={`AVALANCHE is a configurable enterprise risk intelligence platform designed to digitize risk management workflows, streamline governance processes, and strengthen enterprise-wide risk visibility.`}
        cardData={cardData}
      />
      <SliderViewSection
        title={"Building Resilient & Risk-Aware Enterprises"}
        subTitle={"Enable proactive risk management through connected workflows, AI-driven insights, enterprise-wide visibility, and structured governance frameworks designed to improve resilience, productivity, and operational performance."}
        data={safetyAndSustainabilityData} />
      <TestimonialSlider testimonials={testimonialsData} />
      <PlanCards productName = {"Avalanche"} title={"Avalanche Deployment Plans"} plans={AuroraSRPPlans} />
      <ContactUs />
      <StayInLoop />
    </>
  );
}
